export const ONESIGNAL_INIT_ERROR = 'Onesignal: Init';
export const ONESIGNAL_REQUEST_PERMISSION_ERROR = 'Onesignal: RequestPermission';
export const ONESIGNAL_UPDATE_CONSENT_ERROR = 'Onesignal: UpdateConsent';
export const ONESIGNAL_INCORRECT_DEVICE_ID_ERROR = 'Onesignal: IncorrectDeviceId';
export const ONESIGNAL_PERMISSION_QUERY_ERROR = 'Onesignal: PermissionQuery';
